/**** mgt.Replace_Vehicle */
import moment       from 'moment';
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const dowToDay: { [key: string]: string } = {
  '0': 'Понедельник',
  '1': 'Вторник',
  '2': 'Среда',
  '3': 'Четверг',
  '4': 'Пятница',
  '5': 'Суббота',
  '6': 'Воскресенье',
};

const config = {
  schema: 'mgt',
  table: 'Replace_Vehicle',
  title: 'Замены ТС на маршруте',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  // hideInMenu: true,
  connections: {
    raspvars: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'RaspVariants',
      index: 'id',
      fields: ['id', 'route_short_name', 'dow', 'startdate', 'enddate', 'srv_id'],
      customsql: `SELECT vr.id, rt.route_short_name,vr.dow, vr.startdate, vr.enddate, vr.srv_id
                  FROM mgt."RaspVariants" vr
                  INNER JOIN mgt."Routes" rt ON rt.route_id=vr.route_id`,
      format: (elem: any) =>
        `${elem['route_short_name']} - ${dowToDay[elem['dow'] + ''] ||
          'Любой день'} (${ elem['startdate'] ? moment(elem['startdate']).format('DD.MM.YYYY') : '?' }-${ elem['enddate'] ? moment(elem['enddate']).format('DD.MM.YYYY') : '?' }, ${elem['srv_id']})`,
      autocomplete: true,
    },
    vehicle: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Vehicle',
      index: 'vehicle_id',
      fields: ['depot_number'],
      format: (elem: any) => elem['depot_number'],
      autocomplete: true,
    },
    driver: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Driver',
      index: 'driver_id',
      fields: ['last_name', 'first_name', 'middle_name'],
      format: (elem: any) =>
        `${elem['last_name'] || ''} ${elem['first_name'] || ''} ${elem[
          'middle_name'
        ] || ''}`,
      autocomplete: true,
    },
  },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'date',
      title: 'Дата',
      type: 'date',
      required: true,
    },
    {
      name: 'RaspVariant_id',
      title: 'Вариант расписания',
      type: 'number',
      required: true,
      connection: 'raspvars',
    },
    {
      name: 'graph',
      title: 'Номер выхода',
      type: 'connectionlist',
      required: true,
      filterSql: (row: any) => {
        return `SELECT DISTINCT graph FROM mgt."RaspTime" WHERE "RaspVariant_id"=${row['RaspVariant_id']} ORDER BY graph`
      },
      convert: (elem: any) => {
        return { key: elem['graph'], value: elem['graph'] };
      }
    },
    {
      name: 'smena',
      title: 'Номер смены',
      type: 'connectionlist',
      required: true,
      filterSql: (row: any) => {
        return `SELECT DISTINCT smena FROM mgt."RaspTime" WHERE "RaspVariant_id"=${row['RaspVariant_id']} ORDER BY smena`
      },
      convert: (elem: any) => {
        return { key: elem['smena'], value: elem['smena'] };
      }
    },
    {
      name: 'vehicle_id',
      title: 'ТС заменяемое',
      type: 'number',
      required: true,
      connection: 'vehicle',
    },
    {
      name: 'replace_vehicle_id',
      title: 'ТС вышедшее на замену',
      type: 'number',
      required: true,
      connection: 'vehicle',
    },
    {
      name: 'driver_id',
      title: 'Водитель',
      type: 'number',
      required: true,
      connection: 'driver',
    },
    {
      name: 'starttime',
      title: 'Время начала замены',
      type: 'timeminutes',
      required: true,
    },
  ],
  newTemplate: {
    id: null,
    date: null,
    RaspVariant_id: null,
    graph: null,
    smena: null,
    vehicle_id: null,
    replace_vehicle_id: null,
    driver_id: null,
    starttime: null
  },
  updateField: 'update_date',
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  hideImport: true,
  import: {
    header: [
      {
        title: 'date',
        field: 'date',
      }, {
        title: 'route_id',
        field: 'route_id',
      }, {
        title: 'service_id',
        field: 'service_id',
      }, {
        title: 'grafic',
        field: 'graph',
      }, {
        title: 'shift_num',
        field: 'smena',
      }, {
        title: 'vehicle_id_1',
        field: 'vehicle_id',
      }, {
        title: 'vehicle_id_2',
        field: 'replace_vehicle_id',
      }, {
        title: 'worker_id',
        field: 'driver_id',
      }, {
        title: 'time',
        field: 'starttime',
      }
    ],
    example: `2020-01-01;1;1;1;1;1;1;1;10:00`,
    customInsert: 'function (elem, nextIdFunc) { \
      let tm =  elem.starttime.split(":").reduce((last, cur, index) => last+parseInt(cur)*(index==0?60:1) ,0);\
      let sql = `INSERT INTO mgt."Replace_Vehicle" (date, "RaspVariant_id", graph, smena, vehicle_id, replace_vehicle_id, driver_id, starttime, update_date)\
              SELECT \'${elem.date}\', rv.id, ${elem.graph}, \'${elem.smena}\', ${elem.vehicle_id}, ${elem.replace_vehicle_id}, ${elem.driver_id}, ${tm}, now()  FROM mgt."RaspVariants" rv WHERE rv.srv_id=${elem.service_id} and rv.route_id=${elem.route_id} and (rv.startdate is null or \'${elem.date}\'>=rv.startdate) AND (rv.enddate is null or \'${elem.date}\'<=rv.enddate) and extract(dow from \'${elem.date}\'::date)=rv.dow`;\
      return sql; \
    }'
  },
  export: {
    fields: [
      {
        name: 'date',
        title: 'Дата',
        type: 'date'
      },
      {
        name:             'route_name',
        title:            'Маршрут',
        connection:       'routes',
        connectionKey:    'stop_id',
        connectionGetField: 'route_short_name',
      },
      {
        name: 'vehicle_type',
        title: 'Тип ТС',
        connection: 'vehicle_type'
      },
      {
        name: 'RaspVariant_id',
        title: 'Вариант расписания',
        connection: 'raspvar',
        connectionGetField: 'raspvar',
      },
      {
        name: 'graph',
        title: 'Номер выхода',
      },
      {
        name: 'smena',
        title: 'Номер смены',
      },
      {
        name: 'vehicle_id',
        title: 'ТС заменяемое',
        type: 'number',
        required: true,
        connection: 'vehicle',
      },
      {
        name: 'replace_vehicle_id',
        title: 'ТС вышедшее на замену',
        connectionField: 'vehicle_id'
      },
      {
        name: 'driver_id',
        title: 'Водитель',
        format: {
          fields: ['last_name', 'first_name', 'middle_name'],
          template: '%1 %2 %3'
        }
      },
      {
        name: 'starttime',
        title: 'Время начала замены',
        type: 'minutes'
      },
    ],
    connections: {
      raspvar: {
        index: 'RaspVariant_id',
        customsql: 
          `
            SELECT
                r.route_short_name ||  ' - ' ||
                CASE
                    WHEN rv.dow IS NULL THEN 'Любой день'
                    WHEN rv.dow = 0 THEN 'воскресенье'
                    WHEN rv.dow = 1 THEN 'понедельник'
                    WHEN rv.dow = 2 THEN 'вторник'
                    WHEN rv.dow = 3 THEN 'среда'
                    WHEN rv.dow = 4 THEN 'четверг'
                    WHEN rv.dow = 5 THEN 'пятница'
                    WHEN rv.dow = 6 THEN 'суббота'
                    ELSE 'неизвестно'
                end ||  ' (' ||
                COALESCE(rv.startdate::date::text, '?') ||  ' - ' ||  COALESCE(rv.enddate::date::text, '?') || ')'
                AS raspvar
            FROM
                mgt."Replace_Vehicle" rvh
            INNER JOIN
                mgt."RaspVariants" rv ON rvh."RaspVariant_id" = rv.id
            INNER JOIN
                mgt."Routes" r ON rv.route_id = r.route_id
            INNER JOIN
                mgt."Vehicle" v ON rvh.vehicle_id = v.vehicle_id
            INNER join
              mgt."Driver" d on d.depot_id = v.depot_id
            INNER join
              mgt."RaspTime" rt on rt."RaspVariant_id" = rv.id
          `
      }
    },
    routes:   {
        index: 'RaspVariant_id',
        customsql:
          `SELECT
              r.route_short_name,
          FROM
              mgt."Replace_Vehicle" rvh
          JOIN
              mgt."RaspVariants" rv ON rvh."RaspVariant_id" = rv.id
          JOIN
              mgt."Routes" r ON rv.route_id = r.route_id
          JOIN
              mgt."Vehicle" v ON rvh.vehicle_id = v.vehicle_id
          join
            mgt."Driver" d on d.depot_id = v.depot_id
          join
            mgt."RaspTime" rt on rt."RaspVariant_id" = rv.id`
      },
      vehicle_type: {
        index: 'RaspVariant_id',
        customsql:
          `
            SELECT
                v.route_type
            FROM
                mgt."Replace_Vehicle" rvh
            JOIN
                mgt."RaspVariants" rv ON rvh."RaspVariant_id" = rv.id
            JOIN
                mgt."Routes" r ON rv.route_id = r.route_id
            JOIN
                mgt."Vehicle" v ON rvh.vehicle_id = v.vehicle_id
            join
              mgt."Driver" d on d.depot_id = v.depot_id
            join
              mgt."RaspTime" rt on rt."RaspVariant_id" = rv.id
          `,
      },
  }
};

export default config;
